import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useResonanceMessagesListSize = () => {
  const { t } = useTranslation('resonance');

  return useMemo(
    () => [
      {
        label: t('all'),
        value: null,
      },
      {
        label: 5,
        value: 5,
      },
      {
        label: 10,
        value: 10,
      },
      {
        label: 20,
        value: 20,
      },
      {
        label: 50,
        value: 50,
      },
    ],
    [t],
  );
};

export default useResonanceMessagesListSize;
